import { BiddingIntradayOrderWithdrawFailureReason } from '@ebalance/proto/bffuser/v1/bidding_intraday_model_pb'

/**
 * 板取消の失敗確定 (AC-BIN-008b) の説明文の i18n key を、 失敗の理由ごとに引く。
 * 理由で「いま札がどうなっているか」 と「利用者が何をすればよいか」 が変わるので 3 通りに
 * 分ける (文言は design/bidding/intraday.html の `_cancelFailedText` と
 * issue #9241 の Des 確定どおり):
 * - hint: 一覧の「取消失敗」 チップに重ねた時の理由
 * - description: 入札編集 (詳細) の先頭アラートの本文
 * - toast: 失敗確定のエラートーストの本文 (札の概要の後ろに付く)
 */
export type WithdrawFailureTextKeys = {
  hint: string
  description: string
  toast: string
}

const WITHDRAW_FAILURE_TEXT_KEYS: Record<
  BiddingIntradayOrderWithdrawFailureReason,
  WithdrawFailureTextKeys
> = {
  // 理由が付かない失敗確定は、 札が板に残っている前提の案内 (取り下げ直せる側) に倒す。
  [BiddingIntradayOrderWithdrawFailureReason.UNSPECIFIED]: {
    hint: 'page:biddingIntraday.withdrawFailure.retryLimit.hint',
    description: 'page:biddingIntraday.withdrawFailure.retryLimit.description',
    toast: 'page:biddingIntraday.withdrawFailure.retryLimit.toast',
  },
  [BiddingIntradayOrderWithdrawFailureReason.RETRY_LIMIT]: {
    hint: 'page:biddingIntraday.withdrawFailure.retryLimit.hint',
    description: 'page:biddingIntraday.withdrawFailure.retryLimit.description',
    toast: 'page:biddingIntraday.withdrawFailure.retryLimit.toast',
  },
  [BiddingIntradayOrderWithdrawFailureReason.GATE_CLOSED]: {
    hint: 'page:biddingIntraday.withdrawFailure.gateClosed.hint',
    description: 'page:biddingIntraday.withdrawFailure.gateClosed.description',
    toast: 'page:biddingIntraday.withdrawFailure.gateClosed.toast',
  },
  [BiddingIntradayOrderWithdrawFailureReason.FILLED]: {
    hint: 'page:biddingIntraday.withdrawFailure.filled.hint',
    description: 'page:biddingIntraday.withdrawFailure.filled.description',
    toast: 'page:biddingIntraday.withdrawFailure.filled.toast',
  },
}

export function withdrawFailureTextKeys(
  reason: BiddingIntradayOrderWithdrawFailureReason | undefined,
): WithdrawFailureTextKeys {
  return WITHDRAW_FAILURE_TEXT_KEYS[
    reason ?? BiddingIntradayOrderWithdrawFailureReason.UNSPECIFIED
  ]
}
